// store.js
import { localStorageSupported } from '$lib/helper/browser';
import type { BusinessAdmin } from '$lib/model/business';
import type { User } from '$lib/model/user';
import { get, writable } from 'svelte/store';
import { apiStore } from './api';
import { refreshAppData } from './app';
import { businessStore } from './business';
import { t } from './i18n';
import { toast } from './toast';
import { loadUser, userStore } from './user';

// User type
export interface Admin {
	showAdminLinks: boolean;
}

// User store creation
export const adminStore = writable<Admin | null>(null);
userStore.subscribe((user: User | null) => {
	if (user?.role === 'SUPER' && localStorageSupported()) {
		if (!localStorage.getItem('admin')) {
			localStorage.setItem('admin', JSON.stringify({ showAdminLinks: true }));
		}
		adminStore.set(JSON.parse(localStorage.getItem('admin') || '{}'));
	}

	return () => {};
});

adminStore.subscribe((value) => {
	if (value && localStorageSupported()) {
		localStorage.setItem('admin', JSON.stringify(value));
	}

	return () => {};
});

export const adminCurrentBusiness = writable<BusinessAdmin | undefined>(undefined);

export function impersonate(business: BusinessAdmin | undefined) {
	if (!business) return;
	businessStore.set(null);
	userStore.set(null);
	get(apiStore)
		?.post('/admin/impersonate', { user: business.owner.id })
		.then((res) => {
			apiStore.set(get(apiStore));
			loadUser(() => {
				refreshAppData(true);
				get(toast)({
					icon: 'lock',
					bgColor: 'success',
					text: get(t)('impersonate.connected', { name: business.name })
				});
			});
		});
}
